import React, { FC, useMemo } from 'react';
import { Box, Divider, Typography, TypographyProps } from '@mui/material';
import { DETAILS_DRAWER_HEADER_HEIGHT } from '../utils';
import { getDetailsDrawerType } from 'src/DetailsDrawer/store/detailsDrawerSlice';
import { connect } from 'react-redux';
import { RootState } from 'src/store';
import ChipButton from 'src/components/ChipButton';
import UploadIcon from '@mui/icons-material/UpgradeOutlined';

type Props = ReturnType<typeof mapStateToProps>;

const DetailsHeader: FC<Props> = ({ type }) => {
  const Title = useMemo(() => {
    const props: TypographyProps = {
      fontWeight: 700,
      sx: { fontSize: 25 },
    };

    switch (type) {
      case 'RECEIPTS_VIEW': {
        return null;
      }
      case 'RECEIPTS_CREATE': {
        return <Typography {...props}>קבלה חדשה</Typography>;
      }
      case 'REPORTS_AUTOMATIONS_VIEW': {
        return null;
      }
      case 'REPORTS_AUTOMATIONS_CREATE': {
        return null;
      }
      default: {
        return null;
      }
    }
  }, [type]);

  const Actions = useMemo(() => {
    switch (type) {
      case 'RECEIPTS_VIEW': {
        return null;
      }
      case 'RECEIPTS_CREATE': {
        return [
          <ChipButton
            key={`action-0`}
            sx={{
              padding: ({ spacing }) => spacing(0.5, 2, 0.5, 1.25),
              fontWeight: 600,
            }}
            endIcon={
              <UploadIcon
                sx={{
                  fontSize: 18,
                }}
              />
            }
          >
            העלאה אוטומטית
          </ChipButton>,
        ];
      }
      case 'REPORTS_AUTOMATIONS_VIEW': {
        return null;
      }
      case 'REPORTS_AUTOMATIONS_CREATE': {
        return null;
      }
      default: {
        return null;
      }
    }
  }, [type]);

  return (
    <Box
      display="flex"
      flexDirection="column"
      position="relative"
      sx={{
        padding: ({ spacing }) => spacing(0, 2.5, 0, 4),
        minHeight: DETAILS_DRAWER_HEADER_HEIGHT,
        maxHeight: DETAILS_DRAWER_HEADER_HEIGHT,
      }}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        flex={1}
        alignItems="center"
      >
        {Title}
        <Box display="flex" gap={1}>
          {Actions}
        </Box>
      </Box>
    </Box>
  );
};

const mapStateToProps = (state: RootState) => ({
  type: getDetailsDrawerType(state),
});

export default connect(mapStateToProps)(DetailsHeader);
